import React from "react";

function MailingErrorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      fill="none"
      viewBox="0 0 23 24"
    >
      <path
        stroke="#C2210B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.5 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z"
      ></path>
      <path
        fill="#C2210B"
        d="M11.008 14.324l-.564-5.784h2.232l-.576 5.784h-1.092zM10.588 17v-1.92h1.944V17h-1.944z"
      ></path>
    </svg>
  );
}

export default MailingErrorIcon;